module.exports = __webpack_public_path__ + "static/media/skip-button.9787a7e3.png";